import { custom, success } from "./utilities";
import { homeService } from "../../services";
import { globalConstants, homeConstants } from "../../constants";

const {
  ALL_HOBBIES,
  ALL_CURRENCIES,
  DEFAULT_CURRENCY,
  ALL_ALLOWED_COUNTRIES,
  ALL_DAY_TO_DAY_ACTIVITY,
  ALL_MUST_HAVE_AMMENITIES,
} = homeConstants;

//Get all currencies responses
const getAllCurrencies = () => {
  return (dispatch) => {
    homeService.getAllCurrencies().then(
      (response) => {
        dispatch(success(response.data, ALL_CURRENCIES));
      },
      (error) => {}
    );
  };
};

//Get all allowed countries responses
const getAllAllowedCountries = () => {
  return (dispatch) => {
    dispatch(custom(ALL_ALLOWED_COUNTRIES, globalConstants.SPINNER_ACTIVATE));
    homeService
      .getAllAllowedCountries()
      .then(
        (response) => {
          dispatch(success(response.data, ALL_ALLOWED_COUNTRIES));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(
          custom(ALL_ALLOWED_COUNTRIES, globalConstants.SPINNER_DIACTIVATE)
        )
      );
  };
};

//Get all must have ammenities responses
const getAllMustHaveAmmenities = () => {
  return (dispatch) => {
    dispatch(
      custom(ALL_MUST_HAVE_AMMENITIES, globalConstants.SPINNER_ACTIVATE)
    );
    homeService
      .getAllMustHaveAmmenities()
      .then(
        (response) => {
          dispatch(success(response.data, ALL_MUST_HAVE_AMMENITIES));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(
          custom(ALL_MUST_HAVE_AMMENITIES, globalConstants.SPINNER_DIACTIVATE)
        )
      );
  };
};

//Get all hobbies responses
const getAllHobbies = () => {
  return (dispatch) => {
    dispatch(custom(ALL_HOBBIES, globalConstants.SPINNER_ACTIVATE));
    homeService
      .getAllHobbies()
      .then(
        (response) => {
          dispatch(success(response.data, ALL_HOBBIES));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(custom(ALL_HOBBIES, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

//Getting all day to day activity
const getAllDayToDayActivity = () => {
  return (dispatch) => {
    dispatch(custom(ALL_DAY_TO_DAY_ACTIVITY, globalConstants.SPINNER_ACTIVATE));
    homeService
      .getAllDayToDayActivity()
      .then(
        (response) => {
          dispatch(success(response.data, ALL_DAY_TO_DAY_ACTIVITY));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(
          custom(ALL_DAY_TO_DAY_ACTIVITY, globalConstants.SPINNER_DIACTIVATE)
        )
      );
  };
};

const updateDefaultCurrency = (id) => {
  return (dispatch) => dispatch(custom(id, DEFAULT_CURRENCY));
};

export const homeActions = {
  getAllHobbies,
  getAllCurrencies,
  updateDefaultCurrency,
  getAllDayToDayActivity,
  getAllAllowedCountries,
  getAllMustHaveAmmenities,
};
